module.exports = __webpack_public_path__ + "img/130.1.dde7a6f4.jpg";